import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { NGXLogger } from 'ngx-logger';
import { Richiesta } from '../../../models/richiesta.model';
import { StiliService } from '../../../services/stili.service';

@Component({
  selector: 'app-conferma-eliminazione',
  templateUrl: './conferma-eliminazione.component.html',
  styleUrls: ['./conferma-eliminazione.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    RippleModule,
    ToastModule,
    DividerModule
  ],
  providers: [MessageService]
})
export class ConfermaEliminazioneComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() richiesta: Richiesta | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() eliminazioneConfermata = new EventEmitter<number>();

  eliminazioneInCorso: boolean = false;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    public stiliService: StiliService
  ) {}

  ngOnInit() {}

  onHide() {
    // Blocca la chiusura se l'eliminazione è in corso
    if (this.eliminazioneInCorso) {
      return;
    }

    this.visibleChange.emit(false);
  }

  annulla() {
    this.visibleChange.emit(false);
  }

  confermaEliminazione() {
    if (!this.richiesta || !this.richiesta.id) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Impossibile eliminare la richiesta: dati mancanti',
        life: 3000
      });
      return;
    }

    this.eliminazioneInCorso = true;

    // Emetti evento di eliminazione confermata
    this.logger.info(`[CONFERMA-ELIMINAZIONE] Eliminazione confermata per la richiesta ID: ${this.richiesta.id}`);

    // Simuliamo un breve ritardo per l'elaborazione
    setTimeout(() => {
      this.eliminazioneConfermata.emit(this.richiesta!.id);
      this.eliminazioneInCorso = false;
      this.visibleChange.emit(false);
    }, 500);
  }
}
